export type Payload<T, E = unknown> = {
    data?: T | null;
    error?: E | null;
};

type Props<T, E> = {
    payload: Payload<T, E>;
    render?: (data: T) => React.ReactNode;
    renderError?: (error: E) => React.ReactNode;
};

export default function RenderIf<T, E>({ payload, render, renderError }: Props<T, E>) {
    if (payload.error && renderError) {
        return renderError(payload.error);
    }

    if (!payload.error && payload.data !== undefined && payload.data !== null && render) {
        return render(payload.data as T);
    }

    return null;
}
